export default __webpack_public_path__ + "cc13993af3d3a461d7833197667f74b7.png";